import * as _ from 'lodash';
import { ToastService } from '@hss-m/uikit-common';
import { StylistsService } from '../../stylists.service';
import { TYPEHEAD_SEARCH_FILTER } from '../config.const';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilterType } from 'src/app/shared/modules/filters/filters.component';
import { getErrorMsg } from '../../../common/components/dashboard-layout/dashboard.const';
import { MultiTagInputComponent } from 'src/app/components/multi-tag-input/multi-tag-input.component';
import { Component, Output, EventEmitter, Input, AfterViewInit, ElementRef, ViewChildren, QueryList } from '@angular/core';

@Component({
  selector: 'app-add-all-queues-to-queue',
  templateUrl: './add-all-queues-to-queue.html',
  styleUrls: ['./add-all-queues-to-queue.scss']
})
export class AddAllQueuestoQueueComponent implements AfterViewInit {

  selectedProducts: any[];
  selectedUsers: any[];
  filtersConfig = {
    limitSelection: 300,
    badgeShowLimit: 8
  }
  userFilerConfig: any = _.cloneDeep(TYPEHEAD_SEARCH_FILTER.USER);
  productFilerConfig: any = _.cloneDeep(TYPEHEAD_SEARCH_FILTER.PRODUCT);
  loading = false;
  currentSearchText: string;
  filter = {
    date: {
      label: 'Text Date',
      filterType: FilterType.datepicker,
      filterId: 'text_date'
    },
    text: {
      label: 'Additional Text',
      filterType: FilterType.textinput,
      filterId: 'additional_text'
    },
    queue_size: {
      label: 'Queue Size',
      filterType: FilterType.textinput,
      filterId: 'queue_size',
      data: [1]
    }
  };
  textDate = null;
  additionalText = null;
  queueSize = 1;
  @Output() close = new EventEmitter();
  @ViewChildren(MultiTagInputComponent) multiTagInputs: QueryList<MultiTagInputComponent>;
  @Input() usersLoading = false;
  productsLoading = false;
  initialLoading = true;
  hideUsersInput:boolean = false;
  userFilter: MultiTagInputComponent;
  productFilter: MultiTagInputComponent;

  constructor(
    private activeModal: NgbActiveModal, 
    private readonly stylistsService: StylistsService,
    private toastService: ToastService,
    private readonly elmRef: ElementRef
  ) {}

  ngAfterViewInit() {
    if(this.hideUsersInput){
      this.productFilter = this.multiTagInputs.first;
    } else {
      this.userFilter = this.multiTagInputs.first;
      this.productFilter = this.multiTagInputs.last;
    }
  }

  onFiltersValueChange({value, dataKey}: any) {
     if (dataKey === this.userFilerConfig.dataKey) {
      this.selectedUsers = value || [];
     } else {
      this.selectedProducts = value || [];
     }
  }

  onDateChange(event: any) {
    this.textDate = event.value;
  }

  onQueueSizeChange(event: any) {
    this.queueSize = parseInt(event.value);
    this.queueSize = isNaN(this.queueSize) ? 0 : this.queueSize;
  }

  addToQueue() {
    const selectedUsersCount = this.selectedUsers.length;
    const selectedProducts = this.selectedProducts;
    if(selectedUsersCount*selectedProducts.length>200) {
      this.toastService.error({message: `Please don't exceed the 200 user queues limit`});
      return;
    }
    this.loading = true;
    this.stylistsService.addToUsersQueues({
      users: this.selectedUsers.map(usr => usr.id),
      products: selectedProducts.map(pr => pr.id),
      text_date: this.textDate,
      additional_text: this.additionalText,
      queue_size: this.queueSize
    }).subscribe(resp => {
      if(!resp.duplicates || resp.duplicates.length !== selectedProducts.length){
        this.toastService.success({message: `Products has been added to the user(s) queue.`});
      }
      if(resp.duplicates && resp.duplicates.length) {
        this.toastService.error({message: `Few products hasn't been added to avoid duplicates.`});
      }
      this.activeModal.close(true);
      this.loading = false;
    },
    error => {
      const message = getErrorMsg(error);
      this.toastService.error({message});
      this.loading = false;
    });
  }

  isDisabledAddtoQueue() {
    return this.loading || !(this.selectedUsers && this.selectedUsers.length) || (!this.selectedProducts.length && this.queueSize < 1);
  }

  onClose() {
    this.activeModal.dismiss('Cross click');
  }
}
